const actions = {
  GET: 'configuration/GET',
  GET_SUCCESS: 'configuration/GET_SUCCESS',
  GET_ERROR: 'configuration/GET_ERROR',
};

export default actions;
